import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { ProjectregelArtikel } from '../dto/projectregel-artikel';
import { CrudService } from '@mango/core';

@Injectable({ providedIn: 'root' })
export class ProjectregelArtikelService extends CrudService<ProjectregelArtikel> {

    constructor(injector: Injector) { super(ProjectregelArtikel, injector); }

}
